module.exports = __webpack_public_path__ + "img/productsComA.80ab5095.png";